var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 44,
    viewBox: "0 0 186 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.73376 37.3403C-0.315099 34.7514 0.1161 30.981 2.78504 29.0376C29.0544 9.9093 60.9117 -0.140007 93.51 0.520788C126.108 1.18158 157.532 12.5137 183.005 32.6908C185.593 34.7408 185.871 38.5256 183.719 41.0293C181.567 43.533 177.8 43.8069 175.205 41.7659C151.844 23.3936 123.09 13.0788 93.2677 12.4742C63.4455 11.8697 34.2975 21.0108 10.2106 38.4214C7.53489 40.3554 3.78262 39.9292 1.73376 37.3403Z",
    fill: "url(#paint0_linear_710_30226)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_710_30226",
    x1: 88.9925,
    y1: 0.497712,
    x2: 91.988,
    y2: 298.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D4EDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FC69A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB2E86"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBorder);
export default __webpack_public_path__ + "static/media/top-border.e45fe1b9820317a29d8a3ea8a849fe3c.svg";
export { ForwardRef as ReactComponent };